import { faGift } from "@fortawesome/pro-regular-svg-icons";
import { Link, useLocation } from "react-router-dom";

import { T } from "@repo/transifex";
import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import { Button } from "~/components/Button";

export const RedeemRewardsLink = () => {
  const { pathname } = useLocation();

  const { data: userProducts } = useUserProductsPos();

  if (
    userProducts?.stampCardDiscounts &&
    userProducts.stampCardDiscounts.length > 0
  ) {
    return (
      <Link to={`${pathname}/stampcard`}>
        <Button icon={faGift} variant="primary-light">
          <T _str="Redeem Rewards" />
        </Button>
      </Link>
    );
  }

  return null;
};
